import Input from './components/Input';
import ProgressBar from './components/ProgressBar';
import Label from './components/Label';
import LabelGroup from './components/LabelGroup';

export default {
  'uikit/common/components/Input': Input,
  'uikit/common/components/ProgressBar': ProgressBar,
  'uikit/common/components/Label': Label,
  'uikit/common/components/LabelGroup': LabelGroup,
};
